/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pol_Legend_ForbiddenInputs */

const en_pol_legend_forbidden = /** @type {(inputs: Pol_Legend_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The provider does not allow this. Bystep hides the option.`)
};

const id_pol_legend_forbidden = /** @type {(inputs: Pol_Legend_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penyedia melarang cara ini. Bystep menyembunyikan pilihannya.`)
};

/**
* | output |
* | --- |
* | "The provider does not allow this. Bystep hides the option." |
*
* @param {Pol_Legend_ForbiddenInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pol_legend_forbidden = /** @type {((inputs?: Pol_Legend_ForbiddenInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pol_Legend_ForbiddenInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pol_legend_forbidden(inputs)
	return en_pol_legend_forbidden(inputs)
});